import { t } from "ttag";

import { getCategoryName } from "@/features/onboarding/models";
import type { Category } from "@/shared/domains";
import { Button, Dialog, ShieldWarningIcon } from "@/shared/ui";

interface DisqualificationModalProps {
  open: boolean;
  categorySlug: Category["slug"];
  onGoBack: () => void;
  onContinue: () => void;
}

export const PartialDisqualificationModal = ({
  open,
  categorySlug,
  onGoBack,
  onContinue,
}: DisqualificationModalProps) => {
  const categoryName = getCategoryName(categorySlug);

  return (
    <Dialog.Root open={open}>
      <Dialog.Content withCloseButton={false}>
        <Dialog.Header icon={ShieldWarningIcon}>
          <Dialog.Title>
            {t`${categoryName} treatments may not be a fit`}
          </Dialog.Title>

          <Dialog.Description>
            {t`These ${categoryName} treatments might not be the best option for you at the moment — but feel free to keep exploring the other treatments you've selected!`}
          </Dialog.Description>
        </Dialog.Header>

        <Dialog.Footer>
          <Button onClick={onGoBack} variant="secondary" size="lg">
            {t`Back`}
          </Button>

          <Button onClick={onContinue} size="lg">
            {t`Continue`}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
